




















































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { CustomerFreeDescribe, PersonalInfomation } from '@/interface/api'
import { RouteName } from '@/router/index'
import { DateFormat } from '@/utils/constants'
import { formatDate, formatUuid } from '@/utils/index'
import { is050CellPhoneNumber } from '@/utils/validate'
import PhoneNumberInput from '@/components/PhoneNumberInput/PhoneNumberInput.vue'
import { DEFAULT_COUNTRY_CODE } from '@/components/PhoneNumberInput/countryCodeList'

@Component({
  name: 'PersonalInfomationTemplate',
  components: { ValidationProvider, ValidationObserver, PhoneNumberInput }
})
export default class PersonalInfomationTemplate extends Vue {
  public $refs!: {
    form: HTMLFormElement
    phoneNumber: HTMLFormElement
  }

  @Prop({ default: false }) private loading!: boolean
  @Prop({ default: 0 }) private webReservationSexChoices!: number
  @Prop({ default: 0 }) private requireKanjiName!: number
  @Prop({ default: '' }) private medicalBusinessId!: string
  @Prop({ default: '' }) private clinicId!: string
  @Prop({ default: () => [] })
  private customerFreeDescribe!: CustomerFreeDescribe[]

  @Prop({ default: false }) private isMultilingualEnabled!: boolean
  @Prop({ default: 'hidden' }) private emailFieldDisplayMode!:
    | 'hidden'
    | 'optional'
    | 'required'

  private phoneNumber = ''
  private email = ''
  private selectedCountryCode = DEFAULT_COUNTRY_CODE
  private lastName = ''
  private firstName = ''
  private lastNameKana = ''
  private firstNameKana = ''
  private customerDescription = ''
  private selectedSex: number | null = null

  private year = 1970
  private month = 1
  private optionMonths = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
  private day = 1
  private checkbox = false
  private birthdayError = ''
  private sexError = ''

  private get getYears(): number[] {
    const goBackYears = 100
    const currentYear = new Date().getFullYear()
    const startYear = currentYear - goBackYears
    return [...Array(goBackYears + 1).keys()].map(x => x + startYear)
  }

  private get getDays(): number[] {
    const maxDate = this.getFinalDate(this.year, this.month)
    return [...Array(maxDate).keys()].map(x => x + 1)
  }

  private get displaySex(): boolean {
    return (
      this.webReservationSexChoices === 0 ||
      this.webReservationSexChoices === 1 ||
      this.webReservationSexChoices === 4
    )
  }

  /**
   * 国番号に応じた電話番号バリデーションルール
   * +81の場合: 日本の携帯番号フォーマット
   * その他の場合: 国際電話番号フォーマット
   */
  private get phoneValidationRules(): string {
    return `required|phone_number_with_country:${this.selectedCountryCode}`
  }

  /**
   * メールアドレスのバリデーションルール
   * required: 必須 + メール形式チェック
   * optional: メール形式チェックのみ
   */
  private get emailValidationRules(): string {
    return this.emailFieldDisplayMode === 'required'
      ? 'required|email'
      : 'email'
  }

  private get routeName() {
    return RouteName
  }

  @Watch('webReservationSexChoices', { immediate: true })
  private onWebReservationSexChoicesChange(newVal: number) {
    if (newVal === 4) {
      this.selectedSex = null
    } else {
      if (newVal === 0) {
        this.selectedSex = 1
      } else if (newVal === 1) {
        this.selectedSex = 0
      } else if (newVal === 4) {
        this.selectedSex = null
      }
    }
  }

  private formatUuid(id: string): string {
    return formatUuid(id)
  }

  private getFinalDate(year: number, month: number) {
    return new Date(year, month, 0).getDate()
  }

  private validateBirthdate(): boolean {
    const date = new Date(this.year, this.month - 1, this.day)
    if (
      date.getFullYear() === this.year &&
      date.getMonth() === this.month - 1 &&
      date.getDate() === this.day
    ) {
      this.birthdayError = ''
      return true
    }
    this.birthdayError = '正しい日付を選択してください'
    return false
  }

  private validateSex(): boolean {
    if (!this.displaySex) return true
    if (this.selectedSex === null || this.selectedSex === undefined) {
      this.sexError = '性別を選択してください'
      return false
    }
    this.sexError = ''
    return true
  }

  private validate050PhoneNumber(): boolean {
    // 国番号が+81以外の場合は050チェックをスキップ
    if (this.isMultilingualEnabled && this.selectedCountryCode !== '+81') {
      return true
    }
    if (is050CellPhoneNumber(this.phoneNumber)) {
      this.$refs.phoneNumber.setErrors([
        '050から始まる携帯番号はご利用できません'
      ])
      return false
    }
    return true
  }

  private validatePhoneNumber() {
    // バリデーション用のblurハンドラ
    this.$refs.form.validate()
  }

  private async send() {
    const validateResult = await this.$refs.form.validate()
    const validate050PhoneNumber = this.validate050PhoneNumber()
    const validateBirthdateResult = this.validateBirthdate()
    const validateSexResult = this.validateSex()
    if (
      !validateResult ||
      !validate050PhoneNumber ||
      !validateBirthdateResult ||
      !validateSexResult
    )
      return
    let sex = 0
    if (
      this.webReservationSexChoices === 0 ||
      this.webReservationSexChoices === 1 ||
      this.webReservationSexChoices === 4
    ) {
      sex = Number(this.selectedSex)
    } else if (this.webReservationSexChoices === 2) {
      sex = 1
    }

    const personalInfomation: PersonalInfomation = {
      phone_number: this.phoneNumber,
      last_name: this.lastName,
      first_name: this.firstName,
      last_name_kana: this.lastNameKana,
      first_name_kana: this.firstNameKana,
      sex: sex,
      birthdate: formatDate(
        new Date(this.year, this.month - 1, this.day),
        DateFormat.YYYY_MM_DD_HYPHEN
      ),
      email: this.emailFieldDisplayMode !== 'hidden' ? this.email : undefined
    }
    this.checkbox = false
    this.$emit(
      'on-input-personal-info',
      personalInfomation,
      this.customerDescription,
      this.selectedCountryCode
    )
  }
}
